
import { Button } from "@/components/ui/button";
import { BookingFormData } from "../ParcelBookingForm";
import { ArrowLeftRight } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import { Separator } from "@/components/ui/separator";
import MultiContactSection from "../contact-form/MultiContactSection";
import { useMultiContactForm } from "../contact-form/useMultiContactForm";

interface ContactStepProps {
  formData: BookingFormData;
  setFormData: React.Dispatch<React.SetStateAction<BookingFormData>>;
  onValidationChange: (isValid: boolean) => void;
}

const ContactStep = ({
  formData,
  setFormData,
  onValidationChange
}: ContactStepProps) => {
  const isMobile = useIsMobile();
  const {
    handleCollectionContactsChange,
    handleDeliveryContactsChange,
    handleSwapContacts,
    isContactsValid
  } = useMultiContactForm(formData, setFormData, onValidationChange);

  return <div className="space-y-6">
      <div className="flex justify-end">
        <Button variant="outline" size="sm" onClick={handleSwapContacts} className="mb-2 w-full">
          <ArrowLeftRight className="h-4 w-4 mr-2" />
          {isMobile ? "Swap" : "Swap Contacts"}
        </Button>
      </div>

      <MultiContactSection
        title="Collection Contacts"
        contacts={formData.collectionContacts}
        onContactsChange={handleCollectionContactsChange}
        prefix="collection"
      />

      <Separator className="my-4" />

      <MultiContactSection
        title="Delivery Contacts"
        contacts={formData.deliveryContacts}
        onContactsChange={handleDeliveryContactsChange}
        prefix="delivery"
      />
    </div>;
};

export default ContactStep;
